if (!customElements.get('max-height')) {
  let contentId = 0;
  class MaxHeight extends HTMLElement {
    constructor() {
      super();
      this.content = this.querySelector('.max-height--inner-content');
      this.toggle = this.querySelector('.max-height--toggle');
      this.max = this.dataset.max;
    }

    connectedCallback() {
      if (this.controller || !this.content || !this.toggle) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      if (!this.content.id) {
        const sectionId = this.closest('.shopify-section')?.id || 'section';
        let id;
        do { id = `MaxHeightContent-${sectionId}-${++contentId}`; } while (document.getElementById(id));
        this.content.id = id;
      }
      this.toggle.setAttribute('type', 'button');
      this.toggle.setAttribute('aria-controls', this.content.id);
      this.toggle.addEventListener('click', this.onClick.bind(this), options);
      window.addEventListener('resize', this.checkVisible.bind(this), options);
      this.content.addEventListener('focusin', () => {
        if (this.classList.contains('max-height--active')) {
          this.classList.add('max-height--enabled');
          this.syncExpanded();
        }
      }, options);

      this.checkVisible();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }

    checkVisible() {
      if (this.content.offsetHeight > this.max) {
        this.showToggle();
      } else {
        this.hideToggle();
      }
      this.syncExpanded();
    }
    showToggle() {
      this.classList.add('max-height--active');
    }
    hideToggle() {
      this.classList.remove('max-height--active');
    }
    onClick() {
      this.classList.toggle('max-height--enabled');
      this.syncExpanded();
    }
    syncExpanded() {
      const expanded = !this.classList.contains('max-height--active') || this.classList.contains('max-height--enabled');
      this.toggle.setAttribute('aria-expanded', String(expanded));
    }
  }
  customElements.define('max-height', MaxHeight);
}
